module.exports = __webpack_public_path__ + "img/minipro.098bc295.png";